import React, { MouseEventHandler } from 'react';
import { Box, Button, IconButton, } from '@material-ui/core';
import { LastPage, KeyboardArrowRight, KeyboardArrowLeft, FirstPage } from '@material-ui/icons';
import PropTypes from 'prop-types';

/**
 * @param {number} totalPage 總頁數
 * @param {number} page 當前頁碼
 * @param {number} pageRange 左右延伸要幾頁
 * @param {function} onPageChange 換頁事件
 */
type PaginationActionsTSProps = {
    totalPage?: number;
    page?: number;
    pageRange?: number;
    onPageChange: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, nowPage: number) => void
}

/**
 * @description 頁碼 組件
 */
function PaginationActionsTS(props: PaginationActionsTSProps) {
    const { totalPage, page, onPageChange, pageRange } = props;
    let nowPage = page === 0 || page === undefined ? 0 : page;
    // 總頁數
    let totalP = totalPage ? totalPage : 0;
    // 左右延伸要幾頁
    let range = pageRange !== undefined ? pageRange : 2;
    // 左邊有頁數
    let leftItemcount = nowPage - range < 1 ? 1 : nowPage - range;
    // 右邊有頁數
    let rightItemcount = nowPage + range > totalP ? totalP : nowPage + range;

    function handleButtonClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>, targetPage: number) {
        event.preventDefault();
        onPageChange(event, targetPage);
        sessionStorage.setItem("nowPage", (targetPage).toString());
    }

    // 頁碼按鈕
    let btn = [];
    for (let i = leftItemcount; i <= rightItemcount; i++) {
        btn.push(<Button
            key={i}
            data-page={i}
            onClick={(e) => handleButtonClick(e, i)}
            className={page === i ? "pageItem active" : "pageItem"}>
            {i}
        </Button>)
    }

    if (nowPage === 0) {
        return null;
    } else
        return (
            <Box py={3} width="100%" display="flex" justifyContent="center">
                <Box display="inline-flex" justifyContent="center" alignItems="center">
                    <IconButton
                        disabled={nowPage === 1}
                        aria-label="first page"
                        onClick={(e) => handleButtonClick(e, 1)}
                    >
                        <FirstPage />
                    </IconButton>
                    <IconButton
                        onClick={(e) => handleButtonClick(e, nowPage - 1)}
                        disabled={nowPage === 1}
                        aria-label="previous page">
                        <KeyboardArrowLeft />
                    </IconButton>
                    {leftItemcount > 4 ? <Button onClick={(e) => handleButtonClick(e, nowPage - 3)}>...</Button> : ""}
                    {btn.map(item => item)}
                    {totalP - rightItemcount > 4 ? <Button onClick={(e) => handleButtonClick(e, nowPage + 3)}>...</Button> : ""}
                    <IconButton
                        onClick={(e) => handleButtonClick(e, nowPage + 1)}
                        disabled={nowPage >= totalP}
                        aria-label="next page">
                        <KeyboardArrowRight />
                    </IconButton>
                    <IconButton
                        onClick={(e) => handleButtonClick(e, totalP)}
                        disabled={nowPage >= totalP}
                        aria-label="last page">
                        <LastPage />
                    </IconButton>
                </Box>
            </Box>
        );
}

export { PaginationActionsTS };